import React from 'react';
// import PropTypes from 'prop-types';
// import { at } from 'lodash';
// import { useField } from 'formik';
import {
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  TextField,
} from '@mui/material';

// https://omkz.net/en-mu-checkbox-rhf/

export const CheckboxFieldRHFRow = ({
  name,
  label,
  options,
  rhf: { control, Controller, getValues, useWatch },
  error,
}) => {
  //
  // const defaultIds = ['1'];
  const wCompSkills = useWatch({
    control,
    name,
  });

  const handleCheck = (checkedId) => {
    const { [name]: ids } = getValues();
    const newIds = ids?.includes(checkedId)
      ? ids?.filter((id) => id !== checkedId)
      : [...(ids ?? []), checkedId];
    console.log('-----CheckboxFieldRHFRow----' + name + '---->' + newIds);
    return newIds;
  };

  const generateRadioOptions = () => {
    return options.map((singleOption) => (
      <FormControlLabel
        // value={singleOption.value}
        key={singleOption.id}
        label={singleOption.name}
        control={
          // <Radio
          //   sx={{
          //     '& .MuiSvgIcon-root': {
          //       marginLeft: 6,
          //     },
          //   }}
          // />
          <Checkbox
            onChange={() => handleCheck(singleOption.id)}
            // defaultChecked={defaultIds.includes(singleOption.id)}
          />
        }
      />
    ));
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={
          ({ field }) =>
            // <RadioGroup row {...field} sx={{ pl: 2 }}>
            // generateRadioOptions()
            options?.map((singleOption) => (
              <FormControlLabel
                // value={singleOption.value}
                key={singleOption.id}
                label={singleOption.name}
                control={
                  // <Radio
                  //   sx={{
                  //     '& .MuiSvgIcon-root': {
                  //       marginLeft: 6,
                  //     },
                  //   }}
                  // />
                  <Checkbox
                    onChange={() =>
                      field.onChange(handleCheck(singleOption.id))
                    }
                    // defaultChecked={defaultIds.includes(singleOption.id)}
                    // defaultChecked={field.value.includes(singleOption.id)}
                    checked={field.value?.includes(singleOption.id)}
                    // />
                  />
                }
              />
            ))
          // </RadioGroup>
        }
      />{' '}

      {/* อื่นๆ */}
      {wCompSkills?.includes('16') && (
        <Controller
          render={({ field, fieldState: { error } }) => (
            <TextField
              sx={{ ml: 3, mr: 24, mb: 3 }}
              variant="filled"
              label="อื่นๆ"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
              {...field}
            />
          )}
          name="otherComputerSkill"
          control={control}
        />
      )}
      <FormHelperText error={error}>
        {error ? '(' + error.message + ')' : ''}
      </FormHelperText>
      {/* <small className="text-danger">
        {errors?.role && errors.role.message}
      </small> */}
    </>
  );
};

// SelectField.defaultProps = {
//   data: [],
// };

// SelectField.propTypes = {
//   data: PropTypes.array.isRequired,
// };

export default CheckboxFieldRHFRow;
